import Hero from "../components/sections/Hero";
import AboutPreview from "../components/sections/AboutPreview";
import ServicesGrid from "../components/sections/ServicesGrid";
import GlobalMap from "../components/sections/GlobalMap";
import FleetShowcase from "../components/sections/FleetShowcase";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import StatsCounter from "../components/sections/StatsCounter";
import Testimonials from "../components/sections/Testimonials";
import CTABanner from "../components/sections/CTABanner";
import useSEO from "../lib/useSEO";

export default function Home() {
    useSEO({
        title: "Windermere Shipping — Global Maritime Logistics & Chartering",
        description:
            "Singapore-headquartered global maritime logistics, vessel chartering, marine support and cargo transportation. 38 vessels, 60+ trade lanes, IMO compliant.",
        image: "https://images.unsplash.com/photo-1746481594820-04358d2055cd?crop=entropy&cs=srgb&fm=jpg&q=85",
    });

    return (
        <>
            <Hero />
            <AboutPreview />
            <ServicesGrid />
            <GlobalMap />
            <FleetShowcase />
            <WhyChooseUs />
            <StatsCounter />
            <Testimonials />
            <CTABanner />
        </>
    );
}
